// # Privacy Settings Tab Component
import React from 'react';
import PropTypes from 'prop-types';
import './privacy.css';

function PrivacySettings({ isDarkMode }) {
  return (
    <div className="prv_st_section">
      <div className="prv_st_header">
        <h2>Privacy Settings</h2>
      </div>

      <div className="prv_st_content">
        <div className="prv_st_coming-soon">
          <i className="fas fa-lock"></i>
          <h3>Privacy Settings Coming Soon</h3>
          <p>We're working on enhanced privacy controls for your account.</p>
          <p>Features will include:</p>
          <ul>
            <li>Profile visibility controls</li>
            <li>Data sharing preferences</li>
            <li>Communication preferences</li>
            <li>Activity tracking settings</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

PrivacySettings.propTypes = {
  isDarkMode: PropTypes.bool
};

PrivacySettings.defaultProps = {
  isDarkMode: false
};

export default PrivacySettings;
